var render = function render(){var _vm=this,_c=_vm._self._c;return _c('helmi-group-dashboard-card',{staticClass:"helmi-group-dashboard-cumulative-return",attrs:{"initializing":_vm.loadingCharts,"title":"Tuoton jakautuminen kuukausittain","subtitle":"(Brutto)","fullscreen":"","min-height":"560px","use-theme":""}},[_c('h-pie-echart',{attrs:{"data":_vm.echartsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }